function Filter({filters, filterFunction}) {
    return (
        <section className="filters">
            {filters.map((category, index) => {
                return <button key={index} type="button" onClick={()=> filterFunction(category)}>{category}</button>
            }
            )}
        </section>
    )
}

export default Filter
